'use client';

import { c as _c } from "react/compiler-runtime";
import * as Dialog from '@radix-ui/react-dialog';
import Image from 'next/image';
import { overlay } from 'overlay-kit';
import styles from './ConsultationModal.module.scss';
interface ResultModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
}
export default function ResultModal(t0) {
  const $ = _c(12);
  const {
    isOpen,
    onClose
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = open => !open && onClose();
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Dialog.Overlay className={styles.resultOverlay} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.confirmIcon}><Image src="/cc/image/icon_success.svg" alt="success" width={60} height={60} /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Dialog.Title asChild={true}><p className={styles.resultTitle}>상담 신청이 완료되었습니다</p></Dialog.Title>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={styles.resultContent}>{t3}<div className={styles.resultTitleContent}>{t4}<Dialog.Description asChild={true}><div className={styles.resultDescriptionContent}><p><span>02-6339-5900</span> (안심케어 고객센터)</p><p>번호로 연락 드려 자세한 상담 진행을 도와드리겠습니다.</p></div></Dialog.Description></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onClose) {
    t6 = <Dialog.Portal>{t2}<Dialog.Content className={styles.resultContainer}>{t5}<Dialog.Close asChild={true}><button type="button" className={styles.resultConfirmButton} onClick={onClose}>확인</button></Dialog.Close></Dialog.Content></Dialog.Portal>;
    $[6] = onClose;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isOpen || $[9] !== t1 || $[10] !== t6) {
    t7 = <Dialog.Root open={isOpen} onOpenChange={t1}>{t6}</Dialog.Root>;
    $[8] = isOpen;
    $[9] = t1;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}
export function handleResultModal(onClose: () => void) {
  overlay.open(({
    isOpen,
    close
  }) => <ResultModal isOpen={isOpen} onClose={() => {
    close();
    onClose();
  }} />);
}